import React from "react";
import DetailsContainer from "./utils/DetailsContainer";
import UnutilisedTable from "./utils/UnutilisedTable";
import Inventory2Icon from "@mui/icons-material/Inventory2";

const UnutilisedDetails = ({
  id,
  currency,
  currencyRate,
  company,
  dataId,
  title,
  data,
  currentYearLosses,
  onAdd,
  totalAmount,
  onUpdate,
  onRemove,
  onForfeit,
  canEdit = true,
  isCrossYA = false,
}) => {
  const currentYearLossesAmount = Math.abs(parseFloat(currentYearLosses) || 0);
  const hasCurrentYearLosses =
    dataId === "unutilised_losses" &&
    currentYearLosses !== null &&
    currentYearLossesAmount > 0;
  const displayedData = hasCurrentYearLosses
    ? [
        ...(data || []),
        {
          date: new Date(company.yearOfAssessment - 1, 0),
          amount: currentYearLossesAmount,
          preceding_amount: 0,
          current_amount: currentYearLossesAmount,
          historyAmount: [currentYearLossesAmount],
          precedingHistoryAmount: [0],
          currentHistoryAmount: [currentYearLossesAmount],
          reference: "Current Year Losses",
          systemData: true,
          isAgreed: false,
          toDeclareAgreement: false,
          agreementStatus: { dateOfNOA: null, isAgreed: null },
        },
      ]
    : data || [];
  const displayedTotalAmount = hasCurrentYearLosses
    ? (parseFloat(totalAmount) || 0) - currentYearLossesAmount
    : totalAmount;

  return (
    <DetailsContainer
      id={id}
      title={title}
      onAdd={onAdd}
      showAddButton={canEdit}
      totalAmount={displayedTotalAmount}
      icon={Inventory2Icon}
      rows={displayedData.length}
    >
      <UnutilisedTable
        currency={currency}
        currencyRate={currencyRate}
        company={company}
        dataId={dataId}
        data={displayedData}
        isCrossYA={isCrossYA}
        onUpdate={onUpdate}
        onRemove={onRemove}
        onForfeit={onForfeit}
        noRowsHint='No unutilised details available.'
        maxHeight={500}
        canEdit={canEdit}
      />
    </DetailsContainer>
  );
};

export default UnutilisedDetails;
